/* eslint-disable */

// 页面/组件 一律触发webSocket.js的方法
// webSocket.js方法再去调用vuex存储数据
// 页面/组件 只能去显示vuex的事件 不允许直接调用

// import { createStore } from 'vuex';
import webSocket from '/src/utils/webSocket';

const storageData = {
    recent_userList:JSON.parse(localStorage.getItem('recent_userList')),
    allChat_recordList:JSON.parse(localStorage.getItem('allChat_recordList')),
};
export default {
    state: {
        "recent_userList":storageData.recent_userList||[],// 最近聊天的用户
        "allChat_recordList":storageData.allChat_recordList||{},// 所有聊天记录
        "this_roomId":"",//当前会话房间的id
        "this_roomChatItem":{msgList:[]},//当前会话房间聊天记录
        "myInfo":{},//我的信息
    },

    mutations:{
        // 数据修改
        vuex_setData(state,[key,value]) {
            console.log("【thisUser】的store做setData操作",key,value);
            state[key] = value;
            if(['recent_userList','allChat_recordList'].includes(key)){
                // 转JSON 存储缓存
                localStorage.setItem(key, JSON.stringify(value));
            }
        },
        // 多数据修改
        vuex_setManyData(state,objData){
            for (let key in objData) {
                this.commit('vuex_setData',[key,objData[key]])
            }
        },

        // 存储我的信息
        vuex_setMyInfo(state,objData){
            state['myInfo']=objData.data;
        },

        // 服务器推送新好友
        vuex_addUser(state,objData){
            let newObjData = objData.data;
            state['recent_userList'].unshift(newObjData)
            state['allChat_recordList'][newObjData.friendid]={
                ...newObjData,
                msgList:[],
            };
            console.error(state['allChat_recordList'])
        },

        // 发送成功后 修改记录
        vuex_setMessage(state,objData){
            let newObjData = objData.data;
            let {setType,setValue,id,towhoid,content,time,msgState}=newObjData;
            let get_id = id||towhoid
            let oldMsgList = state['allChat_recordList'][get_id]?.msgList||[]
            let needSetIndex = oldMsgList.findIndex((item)=>{return item.timestamp == newObjData.timestamp})


            // 修改全部聊天记录
            state['allChat_recordList'][get_id]['msgList'][needSetIndex][setType] = setValue;

            // 修改当前聊天界面
            if(state['this_roomId']==get_id){
                state['this_roomChatItem'] = state['allChat_recordList'][get_id]
            }

            // 消息列表
            let old_recentUserList = JSON.parse(JSON.stringify(state['recent_userList']));
            let recentUserIndex = old_recentUserList.findIndex((item)=>{return  item.id == get_id})
            old_recentUserList[recentUserIndex].msgState='endSend';//发送完成

            state['recent_userList'] = old_recentUserList

        },

        // 发送时 存储聊天记录 要修改 消息列表、全部聊天记录、当前聊天记录
        vuex_addMessage(state,objData){

            console.error("存储聊天记录，直接存储 allChat_recordList 中，如果this_roomId==objData.id，则更新this_roomChatItem")

            let newObjData = objData.data;

            let is_me = newObjData.who=='me'
            let myId = state['myInfo']?.myuid
            let myName = state['myInfo']?.name

            let {name,id,towho,towhoid,fromwho,fromwhoid,content,time,msgState}=newObjData;
            let get_name = name||towho||fromwho
            let get_id = id||towhoid||fromwhoid

            let oldMsgList = state['allChat_recordList'][get_id]?.msgList||[]
            oldMsgList.push({
                ...newObjData,
                name:is_me?myName:get_name,
                id:is_me?myId:get_id,
            })

            // 全部聊天记录
            state['allChat_recordList'][get_id]['msgList'] = oldMsgList

            // 当前聊天记录
            if(state['this_roomId']==get_id){
                state['this_roomChatItem'] = state['allChat_recordList'][get_id]
            }

            // 消息列表
            let old_recentUserList = JSON.parse(JSON.stringify(state['recent_userList']));
            let recentUserIndex = old_recentUserList.findIndex((item)=>{return  item.id == get_id})
            let recentUserItem = old_recentUserList[recentUserIndex];
            recentUserItem.content=content;
            recentUserItem.time=time;
            recentUserItem.msgState=msgState;
            old_recentUserList.splice(recentUserIndex,1)
            old_recentUserList.unshift(recentUserItem);
            state['recent_userList'] = old_recentUserList
        },

        // 更新好友列表
        vuex_setRecentUserList(state,objData){
            let newArrayData = objData.data;
            state['recent_userList'] = newArrayData;
            // 预设可能出现的聊天记录
            let old_recordList = state['allChat_recordList'];//
            newArrayData.forEach((item)=>{
                if(!old_recordList[item.id]){
                    old_recordList[item.id]={
                        ...item,
                        msgList:[]
                    }
                }
            })
            state['allChat_recordList'] = old_recordList;
        },

        // 点击某个好友 = 设置和指定用户的聊天
        vuex_onClickUser(state,data){
            state['recent_userList'][data.index]['msgState'] = '';
            // 设置指定用户
            state['this_roomId'] = data.id;
            // 获取和这个用户的聊天记录
            let oldData = state.allChat_recordList[data.id]||{};
            let oldMsgList = oldData?.msgList||[];
            if(!oldMsgList.length){
                webSocket.sendWebSocketMessage({type:'getallmsg',data:{'towho':data.name,'towhoid':data.id}})
            }else{
                state['this_roomChatItem']=oldData
            }
            console.error("点击某个好友",oldData)
        },

        // 初始化指定好友的聊天记录
        vuex_intUserChatItem(state,getData){
            let newObjData = getData.data
            let oldObj = state['allChat_recordList'];
            let oldObjItem = oldObj[newObjData.id]
            let oldMsgList = oldObjItem?.msgList||[];

            let msgList = [
                ...oldMsgList,
                ...newObjData.msgList
            ]

            state['allChat_recordList'][newObjData.id] = {
                ...newObjData,
                msgList:msgList
            }

            if (newObjData.id == state['this_roomId']){
                state['this_roomChatItem'] = state['allChat_recordList'][newObjData.id]
            }
        }

    },
    actions:{

    },
    getters:{
        recent_userList:data=>data.recent_userList,// 最近聊天的用户
        allChat_recordList:data=>data.allChat_recordList,//所有用户列表
        // 当前会话的聊天信息
        this_roomChatItem: data=>data.this_roomChatItem,
        myInfo: data=>data.myInfo,
    }
}
